export default class SplitHeadings {
    constructor(elements) {
        // Guard clause: Ensure elements is a NodeList and not empty
        if (!elements.length) return;

        this.elements = elements;

        // Initialize wrapping and checking for all elements
        this.init();
    }

    // Function to wrap words in spans
    wrapWords(element) {
        if (!element) return;
        element.innerHTML = element.textContent.trim() // remove whitespaces
            .split(/\s+/) // Split by spaces
            .map(word => `<span>${word}</span>`)
            .join(' '); // Rejoin with spaces
    }

    // Function to check if spans are wrapping inside preheading/heading
    checkFlexWrap() {
        this.elements.forEach(container => {
            container.querySelectorAll(':scope > *').forEach(child => {
                const firstSpan = child.querySelector('span');

                if (!firstSpan) return;

                // Check if any span moves to a new line
                const isWrapped = Array.from(child.children).some(span => span.offsetTop > firstSpan.offsetTop);

                // Apply 'wrapped' class directly to the child that is wrapping
                child.classList.toggle('wrapped', isWrapped);
            });
        });
    }

    init() {
        this.elements.forEach(container => {
            // Check if the container has children
            const children = container.children;

            if (children.length) {
                // If it has children, wrap each child's text individually
                container.querySelectorAll(':scope > *').forEach(child => {
                    this.wrapWords(child);
                });
            } else if (container.textContent.trim()) {
                // If no children but has text, wrap the container's own text
                this.wrapWords(container);
            }
        });

        // Ensure only one resize event is added globally
        if (!window._splitHeadingsResizeEventAdded) {
            window.addEventListener('resize', () => this.checkFlexWrap());
            window._splitHeadingsResizeEventAdded = true; // Set flag to prevent multiple listeners
        }

        // Check flex wrap immediately on load
        this.checkFlexWrap();
    }
}